
class StringUtils {
    static replaceAtIndex(str, index, replaceStr) {
        return str.substr(0, index) + replaceStr + str.substr(index + replaceStr.length);
    }
}
export default StringUtils;